import React, { useEffect, useState } from 'react'
import { Card, Col, Row, Input, Label, Button } from 'reactstrap'
import { connect } from "react-redux";
import CustomModal from '../../../../../Components/Modals/CustomModal';
import ViewTaskHistory from './ViewTaskHistory';


function ArchivedTaskData(props) {
    const [taskName, setTaskName] = useState();
    const [taskData, setTaskData] = useState()
    const [openTaskTitle, setOpenTaskTitle] = useState(false)
    const [openReferencePopup, setOpenReferencePopup] = useState(false)
    const [referenceText, setReferenceText] = useState();

    const handleVivewTask = (taskData) => {
        console.log(taskData)
        setTaskData(taskData)
        props.setViewTaskPopup(true)
    }
    const handleViewTaskTitle = (task) => {
        setTaskName(task)
        setOpenTaskTitle(true)
    }

    const handleViewReference = (task) => {
        if (task.sourceType === "Ticket" && task.sourceId) {
            props.setNotificationsDetails({
                tabs: 2,
                details: String(task.sourceId),
                action: true,
                searchparams: String(task.sourceId)
            });
    
            return;
        }
    
        // Existing popup behavior
        setReferenceText(task.reference);
        setOpenReferencePopup(true);
    };

    console.log(props.archivedtasksToDisplay)
    return (
        <>
            <Col md={12} >
                <div>
                    <table className="table custom-scroll-table">
                        <thead className='custom-scroll-table thead'>
                            <tr>
                                <th scope="col" className='text-center'>View</th>
                                <th scope="col" className='text-center'>Priority</th>
                                <th scope="col" className='text-center'>Title</th>
                                <th scope="col" className='text-center'>Status</th>
                                <th scope="col" className='text-center'>Assigned To</th>
                                <th scope="col" className='text-center'>Sign Off</th>
                                <th scope="col" className='text-center'>Planned Start Date</th>
                                <th scope="col" className='text-center'>Planned End Date</th>
                                <th scope="col" className='text-center'>Created By</th>
                                <th scope="col" className='text-center'>Completed At</th>
                                <th scope="col" className='text-center'>Reference</th>
                                <th scope="col" className='text-center'>Source Type</th>
                                {/* <th scope="col" className='text-center'>Source Id</th> */}
                            </tr>
                        </thead>
                        <tbody >
                            {props.archivedtasksToDisplay &&
                                props.archivedtasksToDisplay.map((task) => (
                                    <tr key={task.SWTeamTaskId} >
                                        <td className="cursor-pointer">
                                            <div className="d-flex justify-content-center">
                                                <p className="mr-2 mb-0 d-flex justify-content-center" onClick={() => handleVivewTask(task)}>
                                                    <span className=''>
                                                        {task.SWTeamTaskId}</span>
                                                </p>
                                            </div>
                                        </td>
                                        <td>
                                            <p className='text-center mb-0'>{task.priority}</p>
                                        </td>
                                        <td className="cursor-pointer">
                                            <div className="d-flex">
                                                <p
                                                    className="m-0 comment-paragraph"
                                                    onClick={() => handleViewTaskTitle(task.taskTitle)}>
                                                    {task.taskTitle}
                                                </p>
                                            </div>
                                        </td>
                                        <td style={{ backgroundColor: task.rowColor ? task.rowColor : '' }}>
                                            <>
                                                {/* {task.status ==="Completed"? */}
                                                <p className='mb-0 text-center'>{task.status}</p>
                                            </>
                                        </td>
                                        <td>
                                            <>
                                                <p className='mb-0 text-center'>{task.assignedName}</p>
                                            </>
                                        </td>
                                        <td>
                                            <p className='text-center mb-0'>{task.verifiedName}</p>
                                        </td>
                                        <td className='text-center mb-0'>{task.plannedStartDate}</td>
                                        <td className='text-center mb-0'>{task.plannedEndDate}</td>
                                        <td className='text-center mb-0'>{task.createdBy}</td>
                                        <td className='text-center mb-0'>{task.completedAt}</td>
                                        <td className="cursor-pointer">
                                            <div className="d-flex">
                                                <p
                                                    className="m-0 comment-paragraph"
                                                     onClick={() => handleViewReference(task)}>
                                                    {task.reference}
                                                </p>
                                            </div>
                                        </td>
                                        <td className='mb-0 text-center'>{task.sourceType}</td>
                                        {/* <td className='mb-0 text-center'>{task.sourceId}</td> */}

                                    </tr>
                                ))}
                        </tbody>
                    </table>
                </div>
            </Col>
            <CustomModal
                header={"Task Title"}
                isOpen={openTaskTitle}
                toggle={() => setOpenTaskTitle(!openTaskTitle)}
                size={"md"}
                className='my-task-custom-module'
            >
                <Card className='card-of-problemarea p-2'>
                    <Col md={12} >
                        <p className=' mt-1'>{taskName}</p>
                    </Col>
                </Card>
            </CustomModal>
            <CustomModal
                header={"Reference"}
                isOpen={openReferencePopup}
                toggle={() => setOpenReferencePopup(!openReferencePopup)}
                size={"md"}
                className='my-task-custom-module'
            >
                <Card className='card-of-problemarea p-2'>
                    <Col md={12} >
                        <p className=' mt-1'>{referenceText}</p>
                    </Col>
                </Card>
            </CustomModal>
            <CustomModal
                header={<>
                    <h6>View Task / <b>Task Id :</b>&nbsp;{taskData && taskData.SWTeamTaskId}</h6>
                </>}
                isOpen={props.viewTaskPopup}
                toggle={() => props.setViewTaskPopup(!props.viewTaskPopup)}
                size={"xl"}
                className='my-task-custom-module'
            >
                <>
                    <ViewTaskHistory
                        action={true}
                        setViewTaskPopup={props.setViewTaskPopup}
                        setAllUsersTasks={props.setAllUsersTasks}
                        setAgencyMemberList={props.setAgencyMemberList}
                        agencyMemberList={props.agencyMemberList}
                        userData={props.userData}
                        loggedUserId={props.loggedUserId}
                        teamMemberList={props.teamMemberList}
                        statusList={props.taskStatus}
                        taskList={props.taskList}
                        taskName={taskName}
                        viewTaskData={taskData}
                        handleCloseCreateTaskPopup={props.handleCloseCreateTaskPopup}
                    />
                </>
            </CustomModal>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        token: state.loggedUser.token,
        accessLevel: state.loggedUser.accessLevel,
        status: state.loggedUser.status,
        error: state.loggedUser.error,

    };
};

export default connect(mapStateToProps)(ArchivedTaskData);